import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

function AnnouncementBanner() {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'schedule', 'announcement'), (docSnap) => {
      if (docSnap.exists()) {
        setAnnouncement(docSnap.data());
      } else {
        setAnnouncement(null);
      }
    }, (err) => {
      console.error('Error listening to announcement:', err);
    });
    return () => unsubscribe();
  }, []);

  if (!announcement || !announcement.enabled || dismissed) return null;

  // Check if current time falls within the scheduled window
  const now = new Date();
  const start = new Date(announcement.startDate + 'T' + (announcement.startTime || '00:00'));
  const end = new Date(announcement.endDate + 'T' + (announcement.endTime || '23:59'));

  if (now < start || now > end) return null;

  return (
    <div className="announcement-banner">
      <div className="container announcement-banner-inner">
        <span className="announcement-banner-text">
          {announcement.message}
        </span>
        <button
          className="announcement-banner-close"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss announcement"
        >
          &times;
        </button>
      </div>
    </div>
  );
}

export default AnnouncementBanner;
